module.exports = __webpack_public_path__ + "static/social-7c630660f5837bd6a8fa40691e1f5404.png";